import { invalidateOnMutation, invalidateTableCache } from '@/store/api/tableCacheInvalidation';

import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import AXIOS from './ApiConfig';

export { invalidateTableCache };

export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
	invalidateTags?: string[];
	skipInvalidation?: boolean;
}

interface CustomAxiosResponse extends AxiosResponse {
	message: string;
}

interface CustomAxiosError extends AxiosError {
	response: CustomAxiosResponse;
}

type ApiResponse<T> = {
	data: T | null;
	error: AxiosError | null;
};

export const axiosGet = async <T = unknown,>(suffix: string, config?: AxiosRequestConfig): Promise<ApiResponse<T>> => {
	try {
		const response = await AXIOS.get<T>(suffix, config);
		return { data: response.data, error: null };
	} catch (error) {
		const axiosError = error as CustomAxiosError;
		console.error(axiosError);
		handleErrors(axiosError);
		return { data: null, error: axiosError };
	}
};

export const axiosPost = async <T = unknown,>(
	suffix: string,
	body?: unknown,
	config?: CustomAxiosRequestConfig
): Promise<ApiResponse<T>> => {
	try {
		const response = await AXIOS.post<T>(suffix, body, config);
		invalidateOnMutation(suffix, config?.invalidateTags, config?.skipInvalidation);
		return { data: response.data, error: null };
	} catch (error) {
		const axiosError = error as CustomAxiosError;
		console.error(axiosError);
		handleErrors(axiosError);
		return { data: null, error: axiosError };
	}
};

export const axiosDelete = async <T = unknown,>(
	suffix: string,
	config?: CustomAxiosRequestConfig
): Promise<ApiResponse<T>> => {
	try {
		const response = await AXIOS.delete<T>(suffix, config);
		invalidateOnMutation(suffix, config?.invalidateTags, config?.skipInvalidation);
		return { data: response.data, error: null };
	} catch (error) {
		const axiosError = error as CustomAxiosError;
		console.error(axiosError);
		handleErrors(axiosError);
		return { data: null, error: axiosError };
	}
};

export const axiosPut = async <T = unknown,>(
	suffix: string,
	body?: unknown,
	config?: CustomAxiosRequestConfig
): Promise<ApiResponse<T>> => {
	try {
		const response = await AXIOS.put<T>(suffix, body, config);
		invalidateOnMutation(suffix, config?.invalidateTags, config?.skipInvalidation);
		return { data: response.data, error: null };
	} catch (error) {
		const axiosError = error as CustomAxiosError;
		console.error(axiosError);
		handleErrors(axiosError);
		return { data: null, error: axiosError };
	}
};

export const axiosPatch = async <T = unknown,>(
	suffix: string,
	body?: unknown,
	config?: CustomAxiosRequestConfig
): Promise<ApiResponse<T>> => {
	try {
		const response = await AXIOS.patch<T>(suffix, body, config);
		invalidateOnMutation(suffix, config?.invalidateTags, config?.skipInvalidation);
		return { data: response.data, error: null };
	} catch (error) {
		const axiosError = error as CustomAxiosError;
		console.error(axiosError);
		handleErrors(axiosError);
		return { data: null, error: axiosError };
	}
};

const handleErrors = (error: CustomAxiosError, countryVerification?: boolean) => {
	if (error.response?.message === 'code1' && !countryVerification) {
		window.location.reload();
	} else if (error.response?.status === 404) {
		// <Navigate to="/404" replace={true} />;
		// window.location.replace("/404");
	} else if (
		error.response?.status === 401 &&
		error.response.data?.message === 'Full authentication is required to access this resource.'
	) {
		window.location.replace('/denied_access');
	}
};
